// src/routes/PrivateRoute.jsx

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingComponent from "../components/LoadingComponent";
import { getRequiredAdminFeatureForPath } from "../config/adminFeatureAccess";

/**
 * PrivateRoute forces the authorization before the route can be accessed
 * @returns {HTMLElement} - A route element or redirects
 */
const PrivateRoute = ({ children }: { children: React.ReactElement }) => {
  const { userProfile, userFeatures, authStatus, hasAdminFeature } = useAuth();
  const location = useLocation();

  if (authStatus === "error") {
    return <Navigate to="/unauthorized" replace />;
  }

  if (!userProfile || !userFeatures) {
    return <LoadingComponent />;
  }

  // Check if the route is restricted by role
  if (typeof userProfile?.role === "number" && userProfile.role > 20) {
    // Role not authorized, redirect to the home page
    return <Navigate to="/unauthorized" />;
  }

  const requiredFeature = getRequiredAdminFeatureForPath(location.pathname);
  if (requiredFeature && !hasAdminFeature(requiredFeature)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Authorized, render the children components
  return children; //<Outlet />;
};

export default PrivateRoute;
